export default __webpack_public_path__ + "static/media/Times New Roman.f4e3a464.ttf";